import { render, staticRenderFns } from "./SingleReviewBody.vue?vue&type=template&id=2e3d84c4&scoped=true"
import script from "./SingleReviewBody.vue?vue&type=script&lang=js"
export * from "./SingleReviewBody.vue?vue&type=script&lang=js"
import style0 from "./SingleReviewBody.vue?vue&type=style&index=0&id=2e3d84c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d84c4",
  null
  
)

export default component.exports